class Form {
	constructor(obj) {
		this.init = obj.find('.form-state_init');
		this.success = obj.find('.form-state_success');
		this.form = obj.find('form');
		this.btn = obj.find('.js-apply-btn');
		this.mandatoryInputs = obj.find('.form-input_mandatory input');
		this.mandatoryInputsArr = this.mandatoryInputs.get().map(e => $(e));
		this.mandatoryInputs.keydown(function () {
			$(this).removeClass('form-input_error')
		})
		
		this.form.submit(this.submit.bind(this));
	}

	check() {
		let errors = [];
		this.mandatoryInputs.removeClass('form-input_error');
		for (let i = 0; i < this.mandatoryInputs.length; i++) {
			if (this.mandatoryInputsArr[i].val().length < 1) {
				void this.mandatoryInputsArr[i][0].offsetWidth;
				this.mandatoryInputsArr[i].addClass('form-input_error');
				errors.push(this.mandatoryInputsArr[i]);
			}
		}

		return errors.length ? errors : false;
	}

	submit(e) {
		e.preventDefault();
		if (this.check() !== false) {
			return false;
		}
		this.btn.addClass('_sending');
		
		$.ajax({
			url: '/api.php',
			type: 'post',
			data: new FormData(this.form[0]),
			cache: false,
			contentType: false,
			processData: false,
			success: (data) => {
				this.btn.removeClass('_sending');
				if (data === 'success') {
					this.init.slideToggle(200);
					this.success.slideToggle(200);
				} else {
					alert('Something went wrong, please try again later');
				}
			}
		})
	}
}

module.exports = Form;